import { Component, computed, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { User } from '@app/shared/models/user.model';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { ZendeskFacade } from './zendesk.facade';
import { ZendeskOrigin } from '@app/shared/models/zendesk.model';

const LOADING_VISIBILITY_DELAY_MS = 15000;

@Component({
  selector: 'slotcom-zendesk-button',
  standalone: true,
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './zendesk-button.component.html',
  styleUrls: ['./zendesk-button.component.scss'],
})
export class ZendeskButtonComponent implements OnInit {
  private readonly userRepo = inject(UserRepository);
  private readonly zendeskFacade = inject(ZendeskFacade);
  private readonly destroyRef = inject(DestroyRef);

  readonly state = input<ZendeskOrigin>(ZendeskOrigin.InApp);
  private readonly isDelayPassed = signal(false);
  readonly isVisible = computed(() => this.state() !== ZendeskOrigin.Loading || this.isDelayPassed());

  ngOnInit(): void {
    if (this.state() === ZendeskOrigin.Loading) {
      const timeout = setTimeout(() => this.isDelayPassed.set(true), LOADING_VISIBILITY_DELAY_MS);
      this.destroyRef.onDestroy(() => clearTimeout(timeout));
    }
  }

  get user(): User {
    return this.userRepo.user();
  }

  goToContact(): void {
    this.zendeskFacade.goToContact(this.state());
  }
}
